export default (editor) => {
    const domComponents = editor.DomComponents;

    const src_default = '';
    const defaultType = domComponents.getType('default');
    const model = defaultType.model;
    const type = 'bs-video';

    domComponents.addType(type, {
        model: {
            defaults: Object.assign({}, model.prototype.defaults, {
                'custom-name': 'Embed',
                tagName: 'div',
                resizable: false,
                droppable: false,
                classes: ['embed-responsive', 'embed-responsive-16by9'],
                traits: [
                    {
                        type: 'class_select',
                        options: [
                            { value: 'embed-responsive-21by9', name: '21:9' },
                            { value: 'embed-responsive-16by9', name: '16:9' },
                            { value: 'embed-responsive-4by3', name: '4:3' },
                            { value: 'embed-responsive-1by1', name: '1:1' },
                        ],
                        label: 'Aspect Ratio',
                    },
                ].concat(model.prototype.defaults.traits),
            }),
        },
        isComponent: function (el) {
            if (
                el &&
                el.tagName === 'DIV' &&
                el.className &&
                el.className.includes('embed-responsive')
            ) {
                return { type: type };
            }
        },
        view: {
            init() {
                const props = ['Aspect Ratio'];
                const reactTo = props.map((prop) => `change:${prop}`).join(' ');
                this.listenTo(this.model, reactTo, this.render);
                const comps = this.model.components();
                if (!comps.length) {
                    comps.add(
                        `<video class="embed-responsive-item sio-video" src="${src_default}" controls></video>`
                    );
                }
            },
        },
    });
};
